
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';
import { ServiceName } from '../../../shared/constants/services.enum';
import { SharedService } from '../../../shared/services/shared.service';
import { Utils } from '../../../Utils/utils';
import { CaseService } from '../../../shared/services/case.service';
import { RoutesPath } from '../../../shared/constants/routes-path';
import { LookupKey } from '../../../shared/constants/lookup-keys';
import { LookupService } from '../../../core/services/lookup.service';

@Component({
  selector: 'app-mediations',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './mediations.component.html',
  styleUrl: './mediations.component.scss'
})
export class MediationsComponent {
  serviceName = ServiceName;
  filterForm!: FormGroup;
  sub!: Subscription;
  filteredRows: any[] = [];
  loginName: string;
  memberNumber: string = "";
  pageSize: number = 10;
  totalRecords: number = 0;
  pageIndex: number = 1;
  lang: string = "en";
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private sharedService: SharedService,
    private caseService: CaseService,
    private lookupService: LookupService
  ) {
    this.lang = this.sharedService.getCurrentLang();
    this.loginName = this.sharedService.getUserProfile()?.['Login Name'] ?? '';
    this.memberNumber = this.sharedService.getCsnAccountId('csn');
  }

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    this.filterForm = this.fb.group({
      status: [null],
      search: ['']
    });
    this.getCaseStatus();
    this.getCaseList();
  }

  loading: boolean = false;
  caseList: any = [];
  //This method is used to get cases list
  getCaseList() {
    this.loading = true;
    this.caseList = [];
    this.totalRecords = 0;
    const status = this.filterForm.get('status')?.value;
    const search = this.filterForm.get('search')?.value?.trim() || '';

    let dcMethod = "LIST_OF_CASES";
    let statusValue = status ? status : "";
    let searchValue = search;

    if (searchValue) {
      dcMethod = "QUERY_BY_CASE_NUMBER";
      statusValue = "";
    } else if (statusValue) {
      dcMethod = "QUERY_BY_CASE_STATUS";
      searchValue = "";
    }

    const req = {
      serialNumber: searchValue,
      referenceNumber: "",
      loginName: this.loginName,
      dcMethod: dcMethod,
      memberNumber: this.memberNumber,
      noOfDays: "",
      status: statusValue,
      pageSize: this.pageSize,
      startRowNum: this.pageSize * (this.pageIndex - 1),
      newQuery: this.pageIndex === 1,
      dcEncryptedValue: 'N'
    };
    this.caseService
      .getCaseDetail(req)
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (response['Error Code'] == null && response.SiebelMessage['DC Community Portal Mediation Cases']) {
            this.caseList = Utils.checkIsArray(response.SiebelMessage['DC Community Portal Mediation Cases']);
            this.totalRecords = response?.TotalRecords ?? this.caseList.length;
          } else {
            this.loading = false;
          }
        },
        error: () => {
          this.loading = false;
        },
      });
  }
  caseStatus: any = [];
  // This method is used to get cases status
  getCaseStatus() {
    this.lookupService.post(LookupKey.LOOKUP_URL, {
      "ProcessName": "DC Get List Of Values WF",
      "Type": LookupKey.HLS_CASE_STATUS,
      "LanguageCode": this.lang == 'ar' ? 'ARA' : 'ENU',
      "ParentValue": "",
      "Sub Type": ""
    })
      .subscribe({
        next: (response: any) => {
          if (response['Error Message'] == null && response.SiebelMessage?.['List Of Values']) {
            let lovData = Utils.checkIsArray(response.SiebelMessage?.['List Of Values']);
            if (lovData) {
              this.caseStatus = lovData.filter((item: any) => {
                const orderBy = Number(item?.['Order By'] ?? 0);
                return orderBy >= 500;
              });
            }
          }
        }
      })
  }

  // Searching by case number should clear status filter
  search() {
    this.filterForm.get('status')?.setValue(null);
    this.pageIndex = 1;
    this.getCaseList();
  }

  removeSearch(event: KeyboardEvent) {
    const value = this.filterForm.get('search')?.value?.trim() || '';
    if (value === '') {
      this.search();
    }
  }

  // Selecting a status should clear the case number search
  applyFilter(option: any) {
    this.filterForm.get('search')?.setValue('');
    this.pageIndex = 1;
    this.getCaseList();
  }

  pageChange(page: number) {
    this.pageIndex = page;
    this.getCaseList();
  }

  // This method is used to apply for service
  applyForService() {
    let URL = [`${RoutesPath.SERVICE}/${RoutesPath.MEDIATION}`];
    this.router.navigate(URL)
  }

  // This method is used to view case detail
  view(row: any) {
    let refNumber = "DC Complainant UniqueID";
    if (row['DC SR CreatedBy Login'] == this.loginName) {
      refNumber = row['DC Complainant UniqueID'];
    } else {
      refNumber = row['DC Respondant UniqueID'];
    }
    if (!refNumber) {
      return;
    }
    if (!row['Serial Number']) {
      return;
    }
    let URL = [`${RoutesPath.SERVICE}/${RoutesPath.PUBLIC.MEDIATION_CASE_DETAIL}`];
    this.router.navigate(URL, {
      queryParams: {
        ref: refNumber,
        case: row['Serial Number']
      }
    }
    );
  }
  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

}
